import {
    HttpResponse,
    PositionModel,
    QueryModel,
    RequestParams,
    PositionModelIEnumerableApiResultSuccess,
    PositionModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class PositionsDataService implements CrudService<PositionModel, PositionModel> {
    getAll(query: CrudDataQuery<PositionModel>): Promise<CrudEnumerableResponse<PositionModel>> {
        return ApiService.api.getPositionBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<PositionModel>): Promise<CrudEnumerableResponse<PositionModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<PositionModel>> {
        return ApiService.api.getPositionById(id, params);
    }

    create(item: PositionModel, params?: RequestParams): Promise<CrudResponse<PositionModel>> {
        return ApiService.api.insertPosition(item, params);
    }

    update(item: PositionModel, params?: RequestParams): Promise<PositionModel> {
        return ApiService.api.updatePosition(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<PositionModel> {
        return ApiService.api.patchPosition(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<PositionModel>): Promise<CrudEnumerableResponse<PositionModel>> {
        return ApiService.api.deletePositions(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationPosition(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<PositionModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: PositionModel, params?: RequestParams): Promise<CrudResponse<PositionModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getPositionGroupped(query, params);
    }

}
